import { BillingPlanIds } from '../../../../../../enums/billing-plan-ids';

const PlanTiers = {
  [BillingPlanIds.Free2025Q2]: 1,
  [BillingPlanIds.Starter2025Q2]: 2,
  [BillingPlanIds.Standard2025Q2]: 3,
  [BillingPlanIds.Premium2025Q2]: 4,
};

/**
 * Determines if the selected billing plan is a downgrade from the current billing plan.
 * @param {string} currentBillingPlanId
 * @param {string} selectedBillingPlanId
 * @returns {boolean}
 */
export const getIsDowngradingBillingPlan = (currentBillingPlanId, selectedBillingPlanId) => {
  if (!currentBillingPlanId || !selectedBillingPlanId || currentBillingPlanId === selectedBillingPlanId) {
    return false;
  }

  const currentPlanTier = PlanTiers[currentBillingPlanId];
  const selectedPlanTier = PlanTiers[selectedBillingPlanId];

  // Only consider it a downgrade if both plans are in our hierarchy and selected is lower tier
  return currentPlanTier && selectedPlanTier && currentPlanTier > selectedPlanTier;
};
